import apiClient from './apiClient';

export const fetchQueries = async (params) => {
    return apiClient.get(`/search/queries`, { params }).then((res) => res.data);
};

export const deleteSavedQuery = async (queryName: string) => {
    return apiClient.delete(`/search/query/${queryName}`).then((res) => res.data);
};
